module.exports = __webpack_public_path__ + "img/preloader.a0ada7be.gif";